import {Locale} from '@hebcal/hdate';
import poData from './pt.po.js';
Locale.addLocale('pt', poData);
